<template>
  <div v-show="hasSomeAdvertisement">
    <XSkeletonLoader
      v-show="isAdvertisementLoading"
      :class="$style.advertisement"
      height="100vh"
      width="637px"
    />
    <div
      v-show="!isAdvertisementLoading"
      :class="$style.advertisement"
      data-testid="authAdContent"
    >
      <img
        ref="adImage"
        data-testid="authAdImage"
        :class="$style.image"
        :src="advertisement.fileUrl"
        @click="$emit('click')"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, watch } from 'vue';

export default defineComponent({
  name: 'AuthAdvertisement',
  props: {
    isAdvertisementLoading: {
      type: Boolean,
      default: false,
    },
    hasSomeAdvertisement: {
      type: Boolean,
      default: false,
    },
    advertisement: {
      type: Object,
      default: () => ({}),
    },
    image: {
      type: [Object, HTMLImageElement],
      default: () => ({}),
    },
  },
  emits: ['update:image'],
  setup(props, { emit }) {
    const adImage = ref(props.image);

    watch(adImage, () => {
      emit('update:image', adImage.value);
    });

    return {
      adImage,
    };
  },
});
</script>

<style lang="scss" module>
.advertisement {
  display: none;
}

@include breakpoint('medium') {
  * {
    box-sizing: border-box;
  }

  .advertisement {
    display: flex;
    justify-content: center;
    flex-direction: row;
    overflow: hidden;
    width: 100%;
    max-width: 338px;
    height: 100vh;
    background: var(--color-brand-primary-400);

    .image {
      position: relative;
      width: auto;
      object-fit: cover;
      object-position: center;
      cursor: pointer;
    }
  }
}

@include breakpoint('large') {
  .advertisement {
    width: auto;
    min-width: 338px;
    max-width: 420px;
  }
}

@include breakpoint('extra-large') {
  .advertisement {
    width: 100%;
    min-width: 420px;
    max-width: 637px;
  }
}
</style>
